const en_trans_convertion = {
    "": "conversion",
    add: "add conversion",
    name: "conversion name",
    name_search: "search conversion name",
    goods_conv: "item conversion",
    goods_list: "item conversion list",

    label: {
        goods_orig: "origin item",
        goods_dest: "converted item",
    },

    message: {
        download_excel: "Download Excel template for Serial Number upload",
    },

    error: {
        create: "Failed to perform conversion",
        stock_orig: "Not enough stock for conversion",
        stock_conv: "Invalid conversion quantity",
        sn_qty: "Quantity exceeds required items",
    },

    success: {
        create: "Conversion completed successfully",
    },
}

export default en_trans_convertion;